import LegalShell, { LegalSection } from "@/components/LegalShell";
import Seo from "@/components/Seo";

export default function Rules() {
  return (
    <LegalShell eyebrow="Communauté" title="Règles de la communauté" updated="Juin 2026">
      <Seo title="Règles de la communauté — BIZARRE AI" description="Les règles de la communauté BIZARRE AI : respect, débat, modération et signalement." path="/regles" />
      <p className="text-white/70">
        BIZARRE AI est un espace d'expression et d'entraide. Le principe est simple :
        <span className="text-white"> chacun peut exprimer son opinion, les débats sont encouragés</span>,
        mais les insultes, le harcèlement, les menaces, le racisme, le spam et les comportements
        malveillants ne sont pas tolérés.
      </p>
      <LegalSection n="1" title="Ce qui est encouragé">
        <ul className="space-y-1">
          <li>• Exprimer son opinion, même en désaccord avec le projet ou d'autres membres.</li>
          <li>• Débattre avec respect et argumenter.</li>
          <li>• Partager son expérience et aider les autres.</li>
        </ul>
      </LegalSection>
      <LegalSection n="2" title="Ce qui est interdit">
        <ul className="space-y-1">
          <li>• Insultes, harcèlement, intimidation.</li>
          <li>• Discours haineux, racisme, discriminations.</li>
          <li>• Menaces, incitation à la violence.</li>
          <li>• Spam, publicité non sollicitée, liens malveillants.</li>
          <li>• Inondation de messages (flood) et copier-coller répétitif.</li>
        </ul>
      </LegalSection>
      <LegalSection n="3" title="Modération">
        <p>Les contenus suspects peuvent être placés en file d'attente avant publication. Les nouveaux
        comptes sont davantage contrôlés. Nos modérateurs peuvent masquer ou supprimer un contenu, et
        suspendre ou bannir un compte en cas de manquement. Toutes les actions sont journalisées.</p>
      </LegalSection>
      <LegalSection n="4" title="Signalement">
        <p>Chaque membre peut signaler un contenu (insulte, harcèlement, racisme, menace, spam,
        désinformation, publicité, autre). Les signalements sont examinés par l'équipe de modération.</p>
      </LegalSection>
      <LegalSection n="5" title="Score de confiance">
        <p>Les membres actifs et respectueux voient leurs contenus publiés plus rapidement. Les comptes
        déjà signalés ou récents sont davantage contrôlés.</p>
      </LegalSection>
      <p className="text-white/60">En participant à la communauté, vous acceptez ces règles. Merci de
      contribuer à un espace bienveillant. 💛</p>
    </LegalShell>
  );
}
